import React from 'react';

export const ApiContext = React.createContext({
	refetch: () => {},
});




// WEBPACK FOOTER //
// src/components/home/context.js